<script lang="ts">
  import Modal from '@shared/svelte/Components/Modal.svelte';
  import Icon from '@shared/svelte/Components/Icon.svelte';
  import type { Distributor } from '@shared/types/Distributor'
  
  export let showModal: boolean;
  export let distributors: Distributor[];
  export let selectedDistributor: string = '';
  export let closeModal: () => void;
  export let selectDistributor: (id: any) => void;
</script>

<Modal show={showModal} closeOnBackgroundClick={false} fizzModal={true} size={'medium'} overflow={'auto'}>
  <div class='fizz-inset-square-24'>
    <header class='fizz-space-between fizz-stack-8'>
      <h4 class='fizz-heading-4'>Select Distributors</h4>
      <div class='close-share-sellsheet-modal' on:click={closeModal}>
        <Icon type='X' extraClassNames='fizz-text-brand cursor-pointer' height='16' width='16'></Icon>
      </div>
    </header>
    <div class='fizz-stack-32'>
      <p class='fizz-stack-16'>Product sheets must be associated with a unique distributor catalog</p>
      {#each distributors as distributor}
      <label class='fizz-flex-row-8 fizz-stack-12' for={distributor.name}>
        <input
          type='radio'
          class='fizz-radio-button'
          id={distributor.name}
          name={distributor.name}
          value={distributor.name}
          bind:group={selectedDistributor}
        />
        <span>{distributor.name}</span>
      </label>
      {/each}
    </div>
    <footer class='fizz-flex-row fizz-justify-end fizz-surface'>
      <button class='fizz-button-secondary' on:click={() => selectDistributor(selectedDistributor)} 
        disabled={!selectedDistributor}>
          Create
      </button>
    </footer>
  </div>
</Modal>